var map = {
	"./KINDERNINO-08.jpg": "a762",
	"./KINDERNINO-08.png": "19e8",
	"./ardilla.png": "b7ca",
	"./backgroundLogin.png": "c2a3",
	"./castor.png": "557d",
	"./conejo.png": "dddb",
	"./docDefault.png": "3470",
	"./femenino.png": "5bfa",
	"./gato.png": "8716",
	"./huellita.png": "cf11",
	"./kinderplus_logo_redondo.png": "321a",
	"./kinderplus_ninatarea.webp": "67c4",
	"./klogooficial.png": "7de9",
	"./logokindernino-blanco.png": "af86",
	"./logokindernino.png": "4710",
	"./mapache.png": "8d61",
	"./masculino.png": "e5e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";